// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import myw from 'myWorld/base/core';
import './datasource';
import 'L.Bing';

/**
 * @class Datasource to provide visualisation of Bing basemap layers
 * @name BingDatasource
 */
myw.BingDatasource = myw.Datasource.extend('BingDatasource', {
    statics: {
        layerDefFields: [
            {
                name: 'mapType',
                type: 'enumerator',
                enumerator: ['Road', 'Aerial', 'AerialWithLabels']
            }
        ],
        specFields: [{ name: 'license', type: 'string' }]
    },

    options: {
        license: undefined
    },

    /**
     * Instantiates a leaflet layer from a layer definition
     * @param  {layerDefinition} layerDef
     * @return {L.BingLayer}
     */
    createLayer(layerDef) {
        let layer;
        const license = this.options.license;
        const options = _.extend({}, layerDef.options, {
            type: layerDef.mapType || undefined
        });

        try {
            layer = new L.BingLayer(license, options);
        } catch (e) {
            console.log(`Error instantiating layer '${layerDef.name}'. Exception:${e}`);
        }

        return layer;
    }
});

myw.datasourceTypes['bing'] = myw.BingDatasource;

export default myw.BingDatasource;
